import { useState } from 'react';
import { Form, Input, Button, App, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { put, post } from '@/core/request';
import './Login.less';

const { Title, Text } = Typography;

export default function ForgetPassword() {
    const navigate = useNavigate();
    const { message } = App.useApp();
    const year = new Date().getFullYear();

    let [time, setTime] = useState(59);
    const [verify, setVerify] = useState({
        title: '获取验证码',
        bool: true,
    });
    const [information, setInformation] = useState({
        phone: '',
        verificationCode: '',
        pwd: '',
        confirmPwd: '',
    });

    const handlePwdChange = tip => {
        return e => {
            setInformation({
                ...information,
                [tip]: e.target.value.trim(),
            });
        };
    };

    const handleNextClick = () => {
        if (!information.verificationCode) return message.error('验证码不能为空');
        if (!information.confirmPwd) return message.error('确认密码不能为空');
        if (information.pwd === information.confirmPwd) {
            put('/enterprise/staffs/find-pwd', {
                phone: information.phone,
                pwd: information.pwd,
                verificationCode: information.verificationCode,
            }).then(res => {
                if (res.status_code === 200) {
                    message.success('重置密码成功，请重新登录。');
                    return navigate('/login');
                }
            });
        } else {
            return message.error('两次输入的密码不一致');
        }
    };

    const countDown = () => {
        setInterval(() => {
            if (time >= 1) {
                setTime(--time);
            } else {
                setVerify({
                    ...verify,
                    bool: true,
                });
            }
        }, 1000);
    };

    const getCode = () => {
        post('/enterprise/staffs/send-sms', {
            phone: information.phone,
            type: 1,
        }).then(res => {
            if (res.status_code === 200) {
                setVerify({
                    ...verify,
                    bool: false,
                });
                countDown();
            }
        });
    };

    return (
        <div className="login-page login-centered forget-password-page">
            <div className="login-centered-card forget-password-panel">
                <div className="forget-password-back-row">
                    <Link to="/login" className="login-forgot-link">
                        <i className="bi bi-arrow-left" /> 返回登录
                    </Link>
                </div>

                <div className="login-form-header">
                    <Title level={2} className="login-form-title">
                        找回密码
                    </Title>
                    <Text className="forget-password-desc">验证码将会发送至你的手机</Text>
                </div>

                <Form layout="vertical" size="large" className="login-form forget-password-form" requiredMark={false}>
                    <Input allowClear placeholder="请输入手机号" autoComplete="off" className="hidden-show-phone" />
                    <Input.Password allowClear placeholder="请输入手机号" autoComplete="off" className="hidden-show-phone" />

                    <Form.Item
                        name="phone"
                        label="手机号"
                        className="login-form-item"
                        rules={[
                            {
                                validator: (_, value) => {
                                    if (!/^1\d{10}$/.test(value)) {
                                        return Promise.reject('手机号不正确');
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Input onChange={handlePwdChange('phone')} allowClear placeholder=" " autoComplete="off" prefix={<i className="bi bi-phone login-input-icon" />} />
                    </Form.Item>

                    <Form.Item label="验证码" className="login-form-item forget-password-code-item">
                        <div className="forget-password-code-row">
                            <Input placeholder=" " onChange={handlePwdChange('verificationCode')} prefix={<i className="bi bi-shield-check login-input-icon" />} />
                            {verify.bool ? (
                                <Button type="default" onClick={getCode} className="forget-password-code-btn">
                                    {verify.title}
                                </Button>
                            ) : (
                                <Button type="default" disabled className="forget-password-code-btn">
                                    {time}s 重新获取
                                </Button>
                            )}
                        </div>
                    </Form.Item>

                    <Form.Item
                        name="pwd"
                        label="新密码"
                        className="login-form-item forget-password-pwd-item"
                        help="密码不少于 6 位，必须包含数字或字母（大写或小写）"
                        rules={[
                            {
                                validator: (_, value) => {
                                    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*]{6,}$/.test(value)) {
                                        return Promise.reject('密码不少于 6 位，必须包含数字或字母（大写或小写）');
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Input.Password placeholder=" " allowClear onChange={handlePwdChange('pwd')} autoComplete="off" prefix={<i className="bi bi-lock login-input-icon" />} />
                    </Form.Item>

                    <Form.Item name="confirmPwd" label="确认密码" className="login-form-item">
                        <Input.Password placeholder=" " allowClear onChange={handlePwdChange('confirmPwd')} autoComplete="off" prefix={<i className="bi bi-lock-fill login-input-icon" />} />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit" className="login-submit-btn" onClick={handleNextClick}>
                            重 置
                        </Button>
                    </Form.Item>
                </Form>

                <div className="login-brand-badge">
                    <i className="bi bi-exclamation-circle"></i>
                    内部系统，请共同守护数据与业务安全
                </div>

                <div className="login-footer">&copy;{year} 北京华媒康讯 保留所有权利</div>
            </div>
        </div>
    );
}
